import ISOCountryCodes from "../assets/isoCodes.json";

export function getCountryISOCode(code) {
  const iso2Codes = { ...ISOCountryCodes };
  const iso3Codes = Object.entries(ISOCountryCodes).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [value]: key
    }),
    {}
  );

  return iso2Codes[code] || iso3Codes[code];
}
